import { getStorageInfo } from '@/components/common/getStorageInfo';
import AppConsts from '@/lib/appconst';
import { showTip } from '@/scenes/Common/method';
import { Toast } from 'antd-mobile';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
const qs = require('qs');

const http = axios.create({
  baseURL: AppConsts.remoteServiceBaseUrl,
  timeout: 120000,
  paramsSerializer: function (params) {
    return qs.stringify(params, {
      encode: false,
    });
  },
});

http.interceptors.request.use(
  function (config) {
    // 获取session中的auth认证信息
    const headerAuthInfo = getStorageInfo('', 'headerAuthInfo', '{}', sessionStorage);
    // 手机端改造token信息
    const headersCommon = {
      ...config.headers.common,
      ...headerAuthInfo,
      Authorization: 'Bearer ' + headerAuthInfo.Authorization,
      traceId: uuidv4(),
      'Login-Type': 'WECOM',
    };
    console.log('headerAuthInfo:', headersCommon);
    config.headers.common = headersCommon;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (response) => {
    console.log('x-response:', response);
    if (!response.data.result && !response.data.success && !!response.data.error) {
      showTip({
        content: response.data.error.message,
      });
      return Promise.reject(response.data.error.message);
    }
    return response;
  },
  (error) => {
    console.log('x-error:', error.response);
    // 手机网关拦截报错提示并退出
    const { data: msg, status } = error.response;
    let errorStr = '';
    if (status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      const redirect_uri = `${window.location.protocol}//${window.location.host}`;
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx536f2888253bb858&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=Week#wechat_redirec`;
      return;
    } else if (!!msg && !!msg.error && !!msg.error.message && msg.error.details) {
      errorStr = msg.error.details;
      showTip({
        content: errorStr,
      });
    } else if (!!msg && !!msg.error && !!msg.error.message) {
      errorStr = msg.error.message;
      showTip({
        content: errorStr,
      });
    } else if (!!msg && !!msg.error && !!msg.message) {
      errorStr = msg.message;
      showTip({
        content: errorStr,
      });
    } else if (!!msg) {
      errorStr = msg;
      showTip({
        content: errorStr,
      });
    } else if (!msg) {
      errorStr = '可能是服务器故障，请联系管理员。';
      showTip({
        content: errorStr,
      });
    }
    return Promise.reject(errorStr);
  }
);
export default http;
